 import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./features/landing/landing.module').then(m => m.LandingModule)
    },
    {
        path: 'make-payment/:method_id/:package_id/:partner_id/:lead_id/:booking_id/:order_date/:type/:totalPrice/:paymentAmount/:currency/:grn_token/:countdown/:dummy_name/:purpose/:language/:paymentChannel',
        loadComponent: () => import('./features/payment/make-payment.component').then(m => m.MakePaymentComponent)
    },
    {
        path: 'make-payment',
        loadComponent: () => import('./features/payment/make-payment.component').then(m => m.MakePaymentComponent)
    },
    {
        path: 'pay-success',
        loadComponent: () => import('./features/payment/pay-success/pay-success.component').then(m => m.PaySuccessComponent)
    },
    {
        path: 'pay-failure',
        loadComponent: () => import('./features/payment/pay-failure/pay-failure.component').then(m => m.PayFailureComponent)
    },
    {
        path: 'region-hotels',
        loadComponent: () => import('./features/region-hotels/region-hotels.component').then(m => m.RegionHotelsComponent)
    },
    {
        path: 'hotels',
        loadChildren: () => import('./features/hotels/hotels.module').then(m => m.HotelsModule)
    },
    {
        path: 'verify',
        loadComponent: () => import('./features/auth/verify-redirect/verify-redirect.component').then(m => m.VerifyRedirectComponent)
    },
    {
        path: 'auth',
        loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
    },
    {
        path: 'contact-us',
        loadComponent: () => import('./features/core-pages/contact-us/contact-us.component').then(m => m.ContactUsComponent)
    },
    {
        path: 'about',
        loadComponent: () => import('./features/core-pages/about-us/about-us.component').then(m => m.AboutUsComponent)
    },
    {
        path: 'privacy-policy',
        loadComponent: () => import('./features/core-pages/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
    },
    {
        path: 'terms-and-conditions',
        loadComponent: () => import('./features/core-pages/terms-and-conditions/terms-and-conditions.component').then(m => m.TermsAndConditionsComponent)
    },
    {
        path: 'my-bookings',
        canActivate: [authGuard],
        loadChildren: () => import('./features/bookings/my-bookings.module').then(m => m.MyBookingsModule)
    },
    {
        path: 'wishlist',
        loadChildren: () => import('./features/wishlist/wishlist.module').then(m => m.WishlistModule)
    },
    {
        path: 'hotels/:region',
        loadComponent: () => import('./features/region-hotels/region-hotels.component').then(m => m.RegionHotelsComponent)
    },
    {
        path: 'hotels/:region/:country',
        loadComponent: () => import ('./features/region-hotels/region-hotels.component').then(m => m.RegionHotelsComponent)
    },
    {
        path: 'hotels/:region/:country/:city',
        loadComponent: () => import('./features/hotels/hotel-list-by-city/hotel-list-by-city.component').then(m => m.HotelListByCityComponent)
    },
    {
        path: 'coming-soon',
        loadComponent: () => import('./features/coming-soon/coming-soon.component').then(m => m.ComingSoonComponent)
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];
